import React, { useContext, useEffect, useState } from "react";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import "../../styles/styles.css";
import { useTranslation } from "react-i18next";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import ReinferenceIcon from "../../../../components/SVGComponents/StudyList/Actions/ReinferenceIcon";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import { DirectionalHint } from "@fluentui/react";
import userContext from "../../../../context/users/UserContext";
import { USERTYPES } from "../../../../constants/Constants";

const PatientDetails = ({
  viewportData,
  showForceReinference,
  forceReinference,
  reportDoneStatusState
}) => {
  const {roles} = useContext(userContext)
  const { t } = useTranslation();
  const { getConsistentDateFormat } = useContext(studyReportContext);
  return (
    <>
      <div className="viewport-overlay-patient">
        {viewportData && (
          <>
            <span style={{ lineHeight: "15px" }}>
              <span className="viewport-overlay-key">
                {t("viewer.overlay.patient-id")}:{" "}
              </span>
              <span className="viewport-overlay-value">
                {viewportData?.patientId}
              </span>
            </span>
            {(process.env.REACT_APP_VDC_PLATFORM == "true" ||
              process.env.REACT_APP_VDC_PLATFORM == true) && (
              <span style={{ lineHeight: "15px" }}>
                <span className="viewport-overlay-key">
                  {t("viewer.overlay.order-id")}:{" "}
                </span>
                <span className="viewport-overlay-value">
                  {viewportData?.orderId}
                </span>
              </span>
            )}
            <span style={{ lineHeight: "15px" }}>
              <span className="viewport-overlay-key">
                {t("viewer.overlay.patient-name")}:{" "}
              </span>
              <span className="viewport-overlay-value">
                {viewportData?.patientName}
              </span>
            </span>
            <span
              className="viewport-overlay-value"
              style={{ lineHeight: "15px" }}
            >
              {viewportData?.patientAge?.slice(0, 1) === "0"
                ? viewportData?.patientAge?.slice(1, 3) === "-"
                  ? "-"
                  : viewportData?.patientAge?.slice(1, 3) + " | "
                : viewportData?.patientAge?.slice(0, 3) === "-"
                ? "-"
                : viewportData?.patientAge?.slice(0, 3)}{" | "}
              {viewportData?.patientSex === undefined ||
              viewportData?.patientSex === null ||
              viewportData?.patientSex === "-"
                ? "-"
                : viewportData?.patientSex === "M"
                ? t("viewer.overlay.male")
                : t("viewer.overlay.female")}
            </span>
            {(reportDoneStatusState == 0 || reportDoneStatusState == 1) && showForceReinference && (roles[0] !== USERTYPES.FIRMDOCTOR && roles[0] !== USERTYPES.FIRMTECHNICIAN) && (
              <div
                style={{
                  cursor: "pointer",
                  width: "30px",
                }}
                
              >
                <CustomToolTipHost
                  content={t("viewer.tools.force-reinference")}
                  id="ai-reinference"
                  directionalHint={DirectionalHint.rightCenter}
                >
                  <div
                    className="force-reinference-button"
                    onClick={forceReinference}
                  >
                  <ReinferenceIcon color='#fafafa' />
                  </div>
                </CustomToolTipHost>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default PatientDetails;
